// extracted by mini-css-extract-plugin
module.exports = {"footer":"FooterStyle_footer__25FIT","text":"FooterStyle_text__TobXL","register":"FooterStyle_register__hv_Ah"};